import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { Community } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

export function useCommunity(routeSegment: string | undefined) {
  const { data, error, isLoading, mutate } = useSWR<{ community: Community }>(
    routeSegment ? `/api/communities/${routeSegment}` : null,
    fetcher
  );

  return {
    community: data,
    isLoading,
    isError: error,
    mutate,
  };
}
